const EditPasswordPage = () => import('./_pages/edit_password.vue')
const EditPhonePage = () => import('./_pages/edit_phone.vue')

export default [
  {
    path: '/updatepassword',
    component: EditPasswordPage,
    name: 'EditPasswordPage'
  },
  {
    path: '/updatephone',
    component: EditPhonePage,
    name: 'EditPhonePage'
  }
]
